import { render } from "./linkToBlock.vue?vue&type=template&id=2f63a954&scoped=true&ts=true"
import script from "./linkToBlock.vue?vue&type=script&lang=ts"
export * from "./linkToBlock.vue?vue&type=script&lang=ts"

import "./linkToBlock.vue?vue&type=style&index=0&id=2f63a954&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f63a954"]])

export default __exports__